import axios from "axios";
// import { Logtail } from "@logtail/browser";
import { StopWatch } from 'stopwatch-node';

// const logtail = new Logtail("3egdE3x8gsYKyaWig9b7WaDq");
const MaxTimeout = 30000;

async function getAppoiments(dni, _timeout = false) {
  const sw = new StopWatch('sw');
  sw.start('sw');
  let server = "https://services-dev.gobrilliant.com"
  return axios
    .get(`${server}/colmedica/appointments/user?dni=${dni}`, {},
    _timeout ? { timeout: MaxTimeout } : {})
    .then(data => {
      sw.stop();
      // logtail.info("request colmedica", {
      //   url: `${server}/colmedica/appointments/user?dni=${dni}`,
      //   method: "POST",
      //   time: sw.getTask("sw")?.timeMills
      // });
      return data.data
    })
}

export {
  getAppoiments
};